import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { GET_SPRINT_BOOKING_LINK_DETAILS_DATA } from "../../constants/treatmentBooking/getSprintBookingLinkDetails";


const GET_SPRINT_BOOKING_LINK_DETAILS = gql`
    query GetSprintBookingLinkDetails($bookingId: Int) {
        getSprintBookingLinkDetails(booking_id: $bookingId) {
          success
          message
          data {
            paymentSummary {
              totalAmount
              depositAmount
              payableAmount
              dueAmount
              discountAmount
              processingFeeBearer
              commissionPercentage
            }
            payment_data {
              pay_in_full
              pay_deposit
              pay_on_the_day
              pay_monthly
              is_finance_available
              is_stripe_setup
              is_ryft_setup
              user_payl8tr_status
            }
          }
        }
      }
`

export const GetSprintBookingLinkDetailsAction = () => {
  const dispatch = useDispatch();
  const [
    getSprintBookingLinkDetailsResponseFunction,
    getSprintBookingLinkDetailsResponseData,
  ] = useLazyQuery(GET_SPRINT_BOOKING_LINK_DETAILS, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    onCompleted: ({ getSprintBookingLinkDetails: responseData }) => {
      if (responseData.success) {
        dispatch({
          type: GET_SPRINT_BOOKING_LINK_DETAILS_DATA,
          payload: responseData
        })
      } else {
        // toast.error(responseData?.message)
      }
    },
  });

  const getSprintBookingLinkDetailsQueryData = getSprintBookingLinkDetailsResponseData

  const initGetSprintBookingLinkDetails = (data) => {
    return getSprintBookingLinkDetailsResponseFunction({ variables: data })
  }
  return { initGetSprintBookingLinkDetails, getSprintBookingLinkDetailsQueryData }
}